module.exports = __webpack_public_path__ + "img/icn_bu.998adeeb.svg";